import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Drawer } from 'antd';

import UserManagement from './usermanagement/UserManagement';
import UserProfile from './usermanagement/UserProfile';
import Login from './login/Login';
import LoginCard from './login/LoginCard';

import Overview from './overview/Overview';
import Advertisement from './advertisement/Advertisement';
import AdsAnalytics from './advertisement/AdsAnalytics';
import Search from './search/Search';
import Abtesting from './abtesting/Abtesting';
import Campaign from './campaign/Campaign';
import Subscription from './subscription/Subscription';
import Recommendation from './recommendation/Recommendation';
import Promotion from './promotion/Promotion';
import OrderDetail from './order/OrderDetail';
import Audience from './audience/Audience';
import TrafficManagement from './gtm/traffic/TrafficManagement';
import Marketplace from './marketplace_v3/Marketplace';


/* Components */
import SideNav from './sidenav/SideNav';
import TopNav from './topnav/TopNav';

/* Other pages */
import NotFound from './otherpages/NotFound';


import './app.css';


import {
	userLogout,
	userTimeout
} from '../modules/user';
import {
	organizationList
} from '../modules/organization';

const ScrollToTopPage = () => {
	window.scrollTo(0, 0);
	return null;
};

class App extends Component {
	componentDidMount() {
		const { userTheme, userNav } = this.props;
		if (window.location.search.includes('action=logout')) {
			this.props.userLogout();
			this.props.history.push('/login');
			return;
		}
		localStorage.removeItem('apiKey');
		if (this.props.router.location.pathname === '/login') {
			document.body.setAttribute("data-theme", 'light');
		} else {
			document.body.setAttribute("data-theme", 'light');
		}
		document.body.setAttribute("data-width", userNav ? 'wide' : 'narrow');
		document.addEventListener(
			"SessionExpired",
			(e) => {
				this.props.userTimeout(true);
			},
			false
		);
		if (this.props.userAuthenticated) {
			this.props.organizationList();
		}
	}

	componentDidUpdate(prevProps) {
		const { userTheme, userNav } = this.props;
		if (this.props.router.location.pathname === '/login') {
			document.body.setAttribute("data-theme", 'light');
		} else if (userTheme !== prevProps.userTheme) {
			document.body.setAttribute("data-theme", 'light');
		}
		if (userNav !== prevProps.userNav) {
			document.body.setAttribute("data-width", this.props.userNav ? 'wide' : 'narrow');
		}
	}


	render() {
		const { userProfile, userSessionTimeout } = this.props;
		var userRole = (userProfile.user) ? userProfile.user.role : null;
		var rootUrl = "/";

		const PrivateRoute = ({ component: Component, isAuthenticated, typeAccount, path, ...rest }) => {
			console.log({ path, isAuthenticated, userSessionTimeout });
			return <Route
				{...rest}
				render={props => ((isAuthenticated || userSessionTimeout) ?
					((typeAccount && typeAccount.indexOf(userRole) < 0) || path === "/index.html") ? <Redirect to={rootUrl} /> : <Component {...props} />
					:
					(<Redirect to="/login" />)
				)}
			/>
		};

		var classMainContent = 'mainContent';
		if (['/marketplace'].includes(this.props.router.location.pathname)) {
			classMainContent += ' full';
		}
		return (
			<div className="App">
				{
					(!['/login'].includes(this.props.router.location.pathname)) ?
						<div>
							<TopNav SelectChannel={this.SelectChannel} />
							<SideNav />
							<Drawer
								title="Session Expired"
								placement={`right`}
								closable={false}
								open={userSessionTimeout}
								key={`right`}
							>
								<span>Your session has expired. Please log in again to continue.</span>
								<LoginCard userSessionTimeout={true} />
							</Drawer>
						</div>
						:
						""
				}

				<Switch>
					<Route component={ScrollToTopPage} />
				</Switch>
				<div className={classMainContent} >
					<Switch>
						<Route path="/login" component={Login} />
						<PrivateRoute exact path="/" component={Marketplace} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/index.html" isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/overview" component={Overview} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/campaign" component={Campaign} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/audience" component={Audience} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/search" component={Search} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/abtesting" component={Abtesting} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/recommendation" component={Recommendation} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/subscription" component={Subscription} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/promotion" component={Promotion} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/adsanalytics" component={AdsAnalytics} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/advertisement" component={Advertisement} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/user" component={UserProfile} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/organization" component={UserManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/gtm/traffic" component={TrafficManagement} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<PrivateRoute exact path="/order/:id" component={OrderDetail} isAuthenticated={this.props.userAuthenticated} typeAccount={['superadmin', 'admin', 'user']} />
						<Route path="*" exact component={NotFound} />
					</Switch>
				</div>
			</div>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userSessionTimeout: state.user.userSessionTimeout,
	userProfile: state.user.userProfile,
	userTheme: state.user.userTheme,
	userNav: state.user.userNav
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userTimeout,
			userLogout,
			organizationList,
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
